import logo_headline from './headline.js'
import logo_headline_white from './headline-white.js'

export {
  logo_headline,
  logo_headline_white
}
